
export class LanguageManager {
    static SUPPORTED_LANGUAGES = [
        { code: 'en', name: 'English', nativeName: 'English' },
        { code: 'es', name: 'Spanish', nativeName: 'Español' },
        { code: 'fr', name: 'French', nativeName: 'Français' },
        { code: 'de', name: 'German', nativeName: 'Deutsch' },
        { code: 'it', name: 'Italian', nativeName: 'Italiano' },
        { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
        { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
        { code: 'ru', name: 'Russian', nativeName: 'Русский' },
        { code: 'zh', name: 'Chinese', nativeName: '中文' },
        { code: 'ja', name: 'Japanese', nativeName: '日本語' },
        { code: 'ko', name: 'Korean', nativeName: '한국어' },
        { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
        { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
        { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
        { code: 'th', name: 'Thai', nativeName: 'ไทย' },
        { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' }
    ];

    static LOCALE_ALIASES = {
        'zh-CN': 'zh',
        'zh-TW': 'zh',
        'pt-BR': 'pt',
        'pt-PT': 'pt',
        'in': 'id', // generic Indonesian often 'id' but some systems use 'in'
        'iw': 'he'  // legacy Hebrew if we supported it (we don't yet, but good practice)
    };

    /**
     * Get all supported languages for dropdowns
     */
    static getAllLanguages() {
        return this.SUPPORTED_LANGUAGES.map(l => l.name);
    }

    /**
     * Get full language object by display name
     * @param {string} name 
     */
    static getByName(name) {
        return this.SUPPORTED_LANGUAGES.find(l => l.name === name);
    }

    /**
     * Get full language object by code (fuzzy match)
     * @param {string} code e.g. "en", "en-US"
     */
    static getByCode(code) {
        if (!code) return null;

        // 1. Check exact match or known alias
        if (this.LOCALE_ALIASES[code]) {
            const alias = this.LOCALE_ALIASES[code];
            return this.SUPPORTED_LANGUAGES.find(l => l.code === alias);
        }

        // 2. Normalization (e.g. "en-US" -> "en")
        const normalized = code.split(/[-_]/)[0].toLowerCase();

        // 3. Check for specific legacy codes that might normalize weirdly
        if (normalized === 'in') return this.SUPPORTED_LANGUAGES.find(l => l.code === 'id');

        return this.SUPPORTED_LANGUAGES.find(l => l.code === normalized);
    }

    /**
     * Infer languages from Auth Provider Metadata
     * @param {Object} metadata - Supabase/Google user_metadata
     * @returns {Array<string>} Array of Language Display Names
     */
    static inferFromUserMetadata(metadata) {
        // Unwrap Proxy if present for clearer logging
        const rawMetadata = metadata ? JSON.parse(JSON.stringify(metadata)) : null;
        console.log("[LanguageManager] Inferring from metadata:", rawMetadata);
        const inferred = [];

        if (metadata && metadata.locale) {
            const match = this.getByCode(metadata.locale);
            if (match) {
                console.log(`[LanguageManager] Matched locale '${metadata.locale}' to '${match.name}'`);
                inferred.push(match.name);
            } else {
                console.warn(`[LanguageManager] No match found for locale '${metadata.locale}'`);
            }
        } else {
            console.log("[LanguageManager] No locale found in metadata.");
        }

        return inferred;
    }
}
